import { render, staticRenderFns } from "./DoctorInfoItem.vue?vue&type=template&id=9f2c3476&scoped=true"
import script from "./DoctorInfoItem.vue?vue&type=script&lang=js"
export * from "./DoctorInfoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2c3476",
  null
  
)

export default component.exports